import { LazyMarkdown } from 'components/LazyMarkdown'
import remarkGfm from 'remark-gfm'

export function SlideDeckDescriptionMarkdown({
  children,
  onRendered,
}: {
  children: string
  onRendered?: () => void
}) {
  return (
    <div className="slide-deck-description-markdown">
      <LazyMarkdown remarkPlugins={[remarkGfm]} onRendered={onRendered}>
        {children}
      </LazyMarkdown>
    </div>
  )
}
